export var mixin = {
  filters: {
    // 小数点保留6位
    tofixed (val) {
      let num = val.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
        num = num.substring(0, 6 + index + 1)
      } else {
        num = num.substring(0)
      }
      let result = parseFloat(num).toFixed(6)
      return parseFloat(result)
    },
    // 小数点保留6位，不足2位后面补0
    tofixed2 (val) {
      let num = val.toString()
      if (num.indexOf('.') > -1) {
        // 有小数点
        let index = num.indexOf('.')
        let pointLength = num.split('.')[1].length
        if (pointLength > 1) {
          num = num.substring(0, 6 + index + 1)
          let result = parseFloat(num).toFixed(6)
          return parseFloat(result)
        } else {
          return num + '0'
        }
      } else {
        // 没有小数点
        return num + '.00'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/costMenu/components/mixins.js